import { lazy, Suspense } from 'react';
import { Route } from 'react-router';
import { environmentRoutePaths } from 'core/lib/routePaths/environmentRoutePaths';
import { RouteLoader } from '#components/Loader/RouteLoader';

const Environment = lazy(() => import('environment/central-routes/environment-routes'));

const EnvironmentWasteHierarchy = lazy(() =>
  import('environment/central-routes/environment-routes').then((module) => ({
    default: module.EnvironmentWasteHierarchy,
  })),
);

const EnvironmentEnvironmentalReport = lazy(() =>
  import('environment/central-routes/environment-routes').then((module) => ({
    default: module.EnvironmentEnvironmentalReport,
  })),
);

const EnvironmentRecoveryAndDisposal = lazy(() =>
  import('environment/central-routes/environment-routes').then((module) => ({
    default: module.EnvironmentRecoveryAndDisposal,
  })),
);

export const EnvironmentRouteTree = (
  <Route
    path={environmentRoutePaths.HOME}
    element={
      <Suspense fallback={<RouteLoader />}>
        <Environment />
      </Suspense>
    }
  >
    <Route index element={<EnvironmentWasteHierarchy />} />,
    <Route
      path={environmentRoutePaths.ENVIRONMENTAL_REPORT}
      element={<EnvironmentEnvironmentalReport />}
    ></Route>
    <Route
      path={environmentRoutePaths.RECOVERY_AND_DISPOSAL}
      element={<EnvironmentRecoveryAndDisposal />}
    />
    ,
  </Route>
);

export const preloadEnvironment = () => {
  //Import default export to trigger preload
  void import('environment/central-routes/environment-routes');
};
